import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
    setContactOption,
    setContactDateTimeOption,
    setContactDateAction,
    setContactTimeAction
} from '../store/actions';
import {
    selectResources,
    selectContactOption,
    selectUiStatus,
    selectIsFormValid,
    selectMinimal
} from '../store/selectors';
import { RadioControlGroup, RadioInput, Button } from 'migration-flos-react';
import ContactTime from './contact-time';
import { submitForm } from '../store/form-actions';
import { LoadingSpinner } from 'migration-flos-react';

const ContactOption = ({
    resources,
    contactOption,
    setOption,
    hasTechnicalError,
    isFormValid,
    submit,
    isSubmitting,
    minimal
}) => {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const { section3, button } = resources;

    const handleSubmit = () => {
        setIsSubmitted(true);
        submit();
    };

    return (
        <div className="container">
            <form id="Get-quote-contact-option-form">
                {isSubmitted ? (
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 row">
                        <LoadingSpinner />
                    </div>
                ) : (
                    ''
                )}
                {!minimal && (
                    <>
                        <h3>{section3.title}</h3>
                        <RadioControlGroup value={contactOption} onChangeValue={setOption}>
                            <RadioInput id="phone" value={section3.option1.value} label={section3.option1.title} />
                            <p>{section3.option1.description}</p>
                            <RadioInput id="netmeeting" value={section3.option2.value} label={section3.option2.title} />
                            <p className="col-lg-12 row col-xs-12">
                                {section3.option2.description}
                                <br />
                                {section3.option2.sub}
                            </p>
                        </RadioControlGroup>
                        {contactOption !== '' ? <ContactTime /> : null}
                    </>
                )}
                <div className="col-lg-12 col-xs-12 row u-Space-up">
                    <Button
                        variant="primary"
                        disabled={
                            (minimal && (isSubmitting || !isFormValid)) ||
                            (!minimal && (!isFormValid || hasTechnicalError || isSubmitting))
                        }
                        data-testid="order"
                        minWidth="wide"
                        onClick={handleSubmit}
                        id="get-quote-submit"
                    >
                        {button.order.label}
                    </Button>
                </div>
            </form>
        </div>
    );
};

const mapStates = (state) => ({
    resources: selectResources(state),
    contactOption: selectContactOption(state),
    hasTechnicalError: selectUiStatus(state) === 'error',
    isFormValid: selectIsFormValid(state),
    isSubmitting: selectUiStatus(state) === 'submitting',
    minimal: selectMinimal(state)
});

const mapDispatch = (dispatch) => ({
    setOption: (option) => {
        dispatch(setContactOption(option));
        if (option === 'PHONE') {
            dispatch(setContactDateTimeOption('0'));
        } else {
            dispatch(setContactDateTimeOption(''));
            dispatch(setContactTimeAction(''));
            dispatch(setContactDateAction(''));
        }
    },
    submit: () => dispatch(submitForm())
});

export default connect(mapStates, mapDispatch)(ContactOption);
